import React from "react";
import styled from "styled-components";
import { ArrowRight } from "assets/logos/icons/MediumIcons";
import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";

const getPages = (total, itemsPerPage) => {
  let page = 0;
  const pages: any = [];
  for (let left = total; left > 0; left = left - itemsPerPage) {
    pages.push(page);
    page++;
  }
  return pages;
};

export default function Pagination({
  page,
  itemsPerPage,
  total,
  handleScroll,
}: {
  page: number;
  itemsPerPage: number;
  total: number;
  handleScroll?: () => void;
}) {
  const totalNumberOfPages = Math.ceil(total / itemsPerPage);
  const pages = getPages(total, itemsPerPage);

  const newPages = useLocation<any>();
  const history = useHistory();

  const handleClick = (page) => {
    const newSearch = queryString.stringify({
      ...queryString.parse(newPages.search),
      page,
    });
    history.push({
      ...newPages,
      search: newSearch,
    });
    handleScroll && handleScroll();
  };

  if (!pages?.length) return <></>;

  const arrowLeftIsDisabled = page === 1;
  const arrowRightIsDisabled = totalNumberOfPages === page;

  return (
    <Wrapper>
      <Arrow
        onClick={() => (arrowLeftIsDisabled ? null : handleClick(1))}
        disabled={arrowLeftIsDisabled}
      >
        <StyledArrowLeft size="16" isUnderlined={true} />
      </Arrow>
      <Arrow
        onClick={() => (arrowLeftIsDisabled ? null : handleClick(page - 1))}
        disabled={arrowLeftIsDisabled}
      >
        <StyledArrowLeft size="16" />
      </Arrow>

      {pages.map((p) => {
        const isCurrent = page - 1 === p;
        if (Math.abs(page - p) > 3) {
          return null;
        }

        return (
          <Page
            isCurrent={isCurrent}
            key={p}
            onClick={() => handleClick(p + 1)}
          >
            {p + 1}
          </Page>
        );
      })}
      <Arrow
        onClick={() => (arrowRightIsDisabled ? null : handleClick(page + 1))}
        disabled={arrowRightIsDisabled}
      >
        <StyledArrowRight size="16" />
      </Arrow>

      <Arrow
        onClick={() =>
          arrowRightIsDisabled ? null : handleClick(totalNumberOfPages)
        }
        disabled={arrowRightIsDisabled}
      >
        <StyledArrowRight size="16" isUnderlined={true} />
      </Arrow>
    </Wrapper>
  );
}

const StyledArrowLeft = styled<any>(ArrowRight)`
  border-top: ${(props) => (props.isUnderlined ? "1px solid" : "none")};
  padding-bottom: 4px;
  padding-top: 4px;
  transform: rotate(180deg);
`;

const StyledArrowRight = styled<any>(ArrowRight)`
  border-bottom: ${(props) => (props.isUnderlined ? "1px solid" : "none")};
  padding-bottom: 4px;
  padding-top: 4px;
`;

const Wrapper = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Arrow = styled.div<any>`
  font-size: 16px;
  color: ${(props) =>
    props.disabled
      ? props.theme.colors.muttedHeadlines
      : props.theme.colors.secondary};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  padding: 8px;
  display: flex;
  :hover {
    background-color: ${(props) =>
      props.disabled ? "white" : props.theme.colors.tables.borders};
  }

  svg {
    path {
      fill: ${(props) =>
        props.disabled
          ? props.theme.colors.muttedHeadlines
          : props.theme.colors.secondary};
    }
  }
`;

const Page = styled.span<any>`
  padding: 16px;
  font-size: 16px;
  text-align: center;
  margin-right: 8px;
  cursor: pointer;
  color: ${(props) => props.theme.colors.secondary};
  text-decoration: ${(props) => (props.isCurrent ? "underline" : "none")};

  :hover {
    background-color: ${(props) => props.theme.colors.tables.borders};
  }
`;
